






























import '@/class-component-hooks';
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { EventBus } from '@/event-bus';

@Component
export default class Settings extends Vue {
  showDialog = false;
  @Getter
  currentUser;

  deleteAccount() {
    EventBus.$emit('loading', 'loading');
    this.$store.dispatch('deleteAccount', this.currentUser).then(_ => {
      EventBus.$emit('loaded');
      this.$router.push('login');
    });
  }
}
